"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentDomain = exports.isIFrame = void 0;
var isIFrame = function isIFrame() {
  return window !== window.parent;
};
exports.isIFrame = isIFrame;
var getParentDomain = function getParentDomain() {
  return 'https://wwwdeve.hapag-lloyd.com';
};
exports.getParentDomain = getParentDomain;
//# sourceMappingURL=utils.js.map